import React, { useMemo } from "react";
import { renderHtmlWithLineBreaks } from "../../utils";

const TitleDescription = ({
  title,
  description,
  id
}) => {

  const titleFontSizeClass = useMemo(() => {
    let className = ""
    if (id == "section1") {
      className = "text-[48px] text-[#000000] laptop:text-[40px]";
    } else if (id == "section2") {
      className = "text-[54px] text-[#002E6D] laptop:text-[40px]";
    } else if (id == "section3") {
      className = "text-[54px] text-[#002E6D] laptop:text-[40px]";
    } else if (id == "section4") {
      className = "text-[54px] text-[#002E6D] laptop:text-[40px]";
    } else if (id == "section5") {
      className = "text-[54px] text-[#002E6D] laptop:text-[40px]";
    } else if (id == "section6") {
      className = "text-[54px] text-[#002E6D] laptop:text-[40px]";
    } else if (id == "section7") {
      className = "text-[40px] text-[#002E6D] laptop:text-[40px]";
    } else if (id == "section8") {
      className = "text-[48px] text-[#002E6D]";
    } else if (id == "section9") {
      className = "text-[60px] text-[#252C32]";
    }

    return className
  }, []);
  const descriptionClassName = useMemo(() => {
    let className = "text-[#000000]"
    if (id == "section7") {
      className = "text-[#00A9E7] text-[18px] font-semibold";
    }else if (id == "section1") {
      className = "text-[#000000] text-[20px] ipad:text-[20px]"; 
    }
    else if (id == "section2") {
      className = "text-[#002E6D] text-[16px] ipad:text-[16px] laptop:text-[16px] rtl:text-[16px]";
    } 
    
    else if (id == "section3") {
      className = "text-[#002E6D] text-[18px] w-[768px] max-w-[100%]";
    }
    else if (id == "section4") {
      className = "text-[#002E6D] text-[18px]";
    }
    else if (id == "section5") {
      className = "text-[#002E6D] text-[18px]";
    }
    else if (id == "section6") {
      className = "text-[#002E6D] text-[18px]";
    }
   
    else if (id == "section8") {
      className = "text-[#002E6D] text-[18px]";
    }else if (id == "section9") {
      className = "text-[#5B6871] text-[18px]";
    }
 
    return className
  }, [])

  return (
    <>
      <div className="abc pr-6 rtl:pr-0">
        <h2
          className={`${titleFontSizeClass} text-5xl not-italic font-semibold text-left max767:text-3xl  
       
       
        ${id === "section7" || id === "section8" || id === "section9"
              ? "text-center"
              : "text-left rtl:text-right"
            } 
  `}
        >
          {title}
        </h2>
        <div
          className={`${descriptionClassName}
   not-italic font-normal mt-4  ${id}
      
        ${(id === "section7" || id === "section8" || id === "section9")
              ? " text-center"
              : "text-left rtl:text-right"
            } 
     `}
        >
          {renderHtmlWithLineBreaks(description)}
        </div>
      </div>
    </>
  );
};

export default TitleDescription;
